import {
    CODE_NEED_LOGIN,
    CODE_FLUSH_PAGE,
    CODE_RETURN_TO_CART,
    CODE_NEED_LOGIN_WEAK,
    CODE_FLUSH_PAGE_WEAK,
    CODE_RETURN_TO_CART_WEAK,
} from 'base/config/constant';
import { msgModal } from '@base/lib/ThemeModal';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import router from 'next/router';
import Message from '@base/lib/Message';
import { ModalFuncProps } from 'antd/lib/modal';

type IPropsMap = Partial<Record<'goLogin' | 'reload' | 'goCart', ModalFuncProps>>

export function commonErrorHandler(err: { code: number, message: string }, propsMap?: IPropsMap) {
    const { code, message } = err;
    if (typeof err.code === 'undefined') {
        Message.error(message);
    }

    const strongModalCodes = [
        CODE_NEED_LOGIN,
        CODE_FLUSH_PAGE,
        CODE_RETURN_TO_CART,
    ];
    const severity = strongModalCodes.includes(code) ? 'strong' : 'weak';

    switch (code) {
        case CODE_NEED_LOGIN:
        case CODE_NEED_LOGIN_WEAK:
            msgModal({
                severity,
                content: err.message,
                okText: 'Sign In',
                afterClose: () => router.push(generatePath(RouteEnum.LOGIN, { redirect: window.location.href })),
                ...propsMap?.goLogin
            });
            break;

        case CODE_FLUSH_PAGE:
        case CODE_FLUSH_PAGE_WEAK:
            msgModal({
                severity,
                content: err.message,
                okText: 'RETURN',
                afterClose: () => router.reload(),
                ...propsMap?.reload
            });
            break;

        case CODE_RETURN_TO_CART:
        case CODE_RETURN_TO_CART_WEAK:
            msgModal({
                severity,
                content: err.message,
                okText: 'RETURN',
                afterClose: () => router.push(RouteEnum.CART),
                ...propsMap?.goCart
            });
            break;
        default:
            Message.error(message);
    }
}